export const DUMMY_SERVER_API_URL: string ='https://api.fireball.video';

//export const DUMMY_SERVER_API_URL: string = 'http://localhost:8081';

export const STUDENT_REGISTRATION_URL: string = '/registration/student';
export const TUTOR_REGISTRATION_URL: string = '/registration/tutor';

export const LOGIN_URL: string = '/authentication/login';
export const LOGOUT_URL: string = '/authentication/logout';

export const CREATE_STRIPE_PAYMENT_INTENT_URL =
  '/payment/stripe/create-payment-intent';
export const CREATE_STRIPE_PAYMENT_CONFIRMATION_URL: string =
  '/payment/stripe/confirm-payment';

export const GET_AVAILABLE_TUTOR_SUBSCRIPTION_PLAN_URL: string =
  '/subscription/tutor/available-subscription-plans';
export const GET_TUTOR_SUBSCRIPTION_INFO_URL: string =
  '/subscription/tutor/subscription-info';
export const GET_TUTOR_SUBSCRIPTION_HISTORY_URL: string =
  '/subscription/tutor/subscription-history';
export const CREATE_INVITATION_URL: string =
  '/lesson-invitation/create-invitation';
export const GET_INVITATIONS_LIST_TUTOR_URL: string = 
   '/lesson-invitation/invitations-for-tutor';
export const GET_INVITATIONS_LIST_STUDENT_URL: string = 
   '/lesson-invitation/invitations-for-student';

export const GET_INVITATION_BY_ID_URL: string =
   '/lesson-invitation/invitation?invitationId=';
export const ADD_INVITATION_URL: string =
   '/lesson-invitation/create-invitation';
export const EDIT_INVITATION_URL: string =
   '/lesson-invitation/update-invitation';
export const DELETE_INVITATION_URL: string =
   '/lesson-invitation/delete-invitation';
export const START_LESSON_URL: string =
   '/lesson-invitation/start-lesson';
export const START_LESSON_BY_TOKEN_URL: string =
   '/lesson-invitation/start-lesson-by-token';

export const GET_USERS_URL: string =
   '/user-management/users-list';   
   
export const EMAIL_VERIFICATION_URL: string =
   '/registration/email-verification/';   

export const CONTACT_US_URL: string =
   '/registration/contact-us/';   

export const WHITEBOARD_URL: string =
   '/lesson-invitation/start-whiteboard';
export const WHITEBOARD_BY_TOKEN_URL: string =
   '/lesson-invitation/start-whiteboard-by-token';  
   
export const GET_PAGE_CONTENT_DATA_URL: string = '/page-content/get-page-content';

   

  

